module.exports = __webpack_public_path__ + "static/media/3SquareTriangle.ff40cb4e.jpg";